import React from 'react'
import CrudDinamicoDefinicaoListPageContainer from './CrudDinamicoDefinicaoListPageContainer'

export class CrudDinamicoDefinicaoListPage extends React.Component {
  render() {
    return <CrudDinamicoDefinicaoListPageContainer {...this.props} />
  }
}
